const axios = require("axios").default;

const config = require("./serverCfg").default;

function getParams(extraHeaders) {
  if (config.token) {
    return {
      headers: {
        Authorization: "Bearer " + config.token,
        ...(config.selectedLocation ? {
          LocationId: config.selectedLocation,
        } : {}),
        ...extraHeaders
      }
    };
  }
  return {};
}

export default {
  token(newToken) {
    config.token = newToken;
  },
  selectedLocation(newSelectedLocation) {
    config.selectedLocation = newSelectedLocation;
  },
  refreshToken(newRefreshToken) {
    config.refreshToken = newRefreshToken;
  },
  get(path, extraHeaders = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.coreBaseUrl + path.replace("{{serverSegment}}",config.serverSegment), getParams(extraHeaders))
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  post(path, data, extraHeaders = {}) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.coreBaseUrl + path.replace("{{serverSegment}}",config.serverSegment), data, getParams(extraHeaders))
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  put(path, data, extraHeaders = {}) {
    return new Promise((resolve, reject) => {
      axios
        .put(config.coreBaseUrl + path.replace("{{serverSegment}}",config.serverSegment), data, getParams(extraHeaders))
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  patch(path, data, extraHeaders = {}) {
    return new Promise((resolve, reject) => {
      axios
        .patch(config.coreBaseUrl + path.replace("{{serverSegment}}",config.serverSegment), data, getParams(extraHeaders))
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  delete(path, extraHeaders = {}) {
    return new Promise((resolve, reject) => {
      axios
        .delete(config.coreBaseUrl + path.replace("{{serverSegment}}",config.serverSegment), getParams(extraHeaders))
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getToken() {
    return config.token;
  },
  getFormsBaseUrl() {
    return config.coreBaseUrl;
  },
  setupInterceptors({ getters, dispatch, commit }) {
    const req = {
      pending: () => {
        let requestsPending = getters["layout/getRequestsPending"];
        commit("layout/setRequestsPending", (requestsPending += 1));
        dispatch(`layout/show`);
      },
      done: () => {
        let requestsPending = getters["layout/getRequestsPending"];
        commit("layout/setRequestsPending", (requestsPending -= 1));
        if (requestsPending <= 0) {
          dispatch(`layout/hide`);
        }
      }
    };
    axios.interceptors.request.use(
      config => {
        if (!config.headers["Hide-Loading"]) {
          req.pending();
        }
        return config;
      },
      error => {
        let requestsPending = getters["layout/getRequestsPending"];
        commit("layout/setRequestsPending", (requestsPending -= 1));
        req.done();
        return Promise.reject(error);
      }
    );
    axios.interceptors.response.use(
      data => {
        if (!data.config.headers["Hide-Loading"]) {
          req.done();
        }
        return Promise.resolve(data);
      },
      error => {
        try {
          if (error.response.status === 400 || error.response.status === 403) {
            const errors = Object.values(error.response.data.errors);
            const concatenatedErrors = [].concat.apply([], errors);
            if (concatenatedErrors.length > 0)
              dispatch(`layout/showAlertError`, {
                message: concatenatedErrors.join("<br/>")
              });
            else
              dispatch(`layout/showAlertError`, {
                message: "Error!"
              });
          } else if (error.response.status !== 401) {
            dispatch(`layout/showAlertError`, {
              message: "Error!"
            });
          }
        } catch (error) {
          dispatch(`layout/showAlertError`, {
            message: "Error!"
          });
        }
        req.done();
        return Promise.reject(error);
      }
    );
  }
};
